import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { NfcOutlined } from '@mui/icons-material';
import forumsIcon from '../assets/images/forum_icon.png';

interface SessionEndedProps {
  onRetry?: () => void;
}

const SessionEnded: React.FC<SessionEndedProps> = ({ onRetry }) => {
  const handleScanNFC = () => {
    if (onRetry) {
      onRetry();
    } else {
      // Reload the page to start fresh
      window.location.reload();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        px: 3,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}
    >
      <Box
        sx={{
          backgroundColor: (theme) => 
            theme.palette.mode === 'light' ? 'white' : '#1e1e1e',
          borderRadius: 3,
          p: 3,
          maxWidth: 380,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          border: '1px solid rgba(255,255,255,0.2)',
          maxHeight: '90vh',
          overflowY: 'auto'
        }}
      >
        {/* Forums Icon */}
        <Box
          sx={{
            mx: 'auto',
            mb: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img 
            src={forumsIcon} 
            alt="Sivousplate" 
            style={{ 
              width: 48, 
              height: 48,
              objectFit: 'contain'
            }} 
          />
        </Box>

        <Typography
          variant="h6"
          sx={{
            mb: 1.5,
            fontWeight: 600,
            color: '#2c3e50'
          }}
        >
          Chat Session Ended
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: '#64748b',
            lineHeight: 1.5
          }}
        >
          Your TableChat<sup style={{ fontSize: '0.6em', verticalAlign: 'super' }}>™</sup> session has been cleared by restaurant staff. 
        </Typography>

        <Box sx={{ mb: 2, textAlign: 'left' }}>
          <Typography variant="body2" sx={{ mb: 2, color: '#64748b', fontWeight: 500 }}>
            To start a new chat session:
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: '#64748b', display: 'flex', alignItems: 'center' }}>
            <NfcOutlined sx={{ mr: 1, fontSize: 18, color: '#667eea' }} />
            Scan the NFC tag at your table again
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: '#64748b', display: 'flex', alignItems: 'center' }}>
            • A fresh chat session will be created
          </Typography>
          <Typography variant="body2" sx={{ mb: 1, color: '#64748b', display: 'flex', alignItems: 'center' }}>
            • Your server will be notified you're ready to chat
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<NfcOutlined />}
          onClick={handleScanNFC}
          size="large"
          sx={{
            backgroundColor: '#667eea',
            '&:hover': {
              backgroundColor: '#5a67d8'
            },
            borderRadius: 2,
            py: 1.5,
            px: 3,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(102,126,234,0.3)',
            mb: 2
          }}
        >
          Scan NFC Tag to Start New Session
        </Button>

        <Typography
          variant="caption"
          sx={{
            mt: 2,
            display: 'block',
            color: '#94a3b8'
          }}
        >
          Need help? Ask a staff member to show you the table's NFC tag.
        </Typography>
      </Box>
    </Box>
  );
};

export default SessionEnded;
